import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import CreateUserForm from '../../components/CreateUser/CreateUserForm'
import { toast } from 'sonner'
import { useCreateUser } from '@/features/users'
import { CreateUserFormData } from '../../types'
import styles from '../MapRolePage/MapRolePage.module.scss'

const INITIAL_FORM: CreateUserFormData = {
  emailOrMobile: '',
  password: '',
}

export default function CreateUserPage() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState<CreateUserFormData>(INITIAL_FORM)
  const createUserMutation = useCreateUser()

  const handleFieldChange = <K extends keyof CreateUserFormData>(field: K, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const handleSubmit = () => {
    if (!formData.emailOrMobile.trim() || !formData.password.trim()) {
      toast.error('All fields are required')
      return
    }

    const value = formData.emailOrMobile.trim()
    const identifierType = /^\S+@\S+\.\S+$/.test(value) ? 'email' : 'mobile'

    createUserMutation.mutate(
      {
        identifier: value,
        identifier_type: identifierType,
        password: formData.password,
      },
      {
        onSuccess: () => {
          toast.success('User created successfully')
          setFormData(INITIAL_FORM)
          navigate('/users/active')
        },
        onError: (error) => {
          console.error('Failed to create user', error)
          toast.error('Failed to create user')
        },
      }
    )
  }

  return (
    <div className={styles.pageWrapper}>
      <button type="button" className={styles.backBtn} onClick={() => navigate(-1)}>
        ‹ Back to Users
      </button>

      <div className={styles.card}>
        <CreateUserForm
          formData={formData}
          expanded={true}
          onFieldChange={handleFieldChange}
          onCancel={() => navigate('/users/active')}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  )
}